import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export type ColorScheme = 'light' | 'dark'

export const useLayoutStore = defineStore('layout', () => {
  const colorScheme = ref<ColorScheme>(
    (localStorage.getItem('colorScheme') as ColorScheme) ?? 'light',
  )
  const sidebarVisible = ref(true)

  // Optional breadcrumb override: when set, the breadcrumb shows these crumbs
  // instead of the ones derived from the route path (e.g. a patient's name).
  const breadcrumbOverride = ref<string[] | null>(null)

  function setBreadcrumb(crumbs: string[]): void {
    breadcrumbOverride.value = crumbs
  }

  function clearBreadcrumb(): void {
    breadcrumbOverride.value = null
  }

  const isDark = computed(() => colorScheme.value === 'dark')

  function toggleDarkMode(): void {
    colorScheme.value = isDark.value ? 'light' : 'dark'
    localStorage.setItem('colorScheme', colorScheme.value)
    document.documentElement.classList.toggle('app-dark', isDark.value)
  }

  function toggleSidebar(): void {
    sidebarVisible.value = !sidebarVisible.value
  }

  if (isDark.value) {
    document.documentElement.classList.add('app-dark')
  }

  return {
    colorScheme,
    sidebarVisible,
    isDark,
    breadcrumbOverride,
    toggleDarkMode,
    toggleSidebar,
    setBreadcrumb,
    clearBreadcrumb,
  }
})
